import { MICROSECOND, microsecondsToSeconds, microsecondsToTimestep } from './time.js';
import { yardsToKph, yardsToMph } from './distance.js';
import { SpeedMetric } from '../types/speed.js';

const DEFAULT_OPTIONS = {
    metric: SpeedMetric.MPH,
    offset: MICROSECOND,
};
const byClosestMicrosecond = (microsecond) => ({ timestamp }) => microsecondsToTimestep(microsecond) === timestamp;
const calculateDistance = (x1, x2, y1, y2) => Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
const calculateSpeed = (x1, x2, y1, y2, timeDifference, metric) => {
    const distance = calculateDistance(x1, x2, y1, y2);
    const speedYardsPerSecond = distance / timeDifference;
    if (metric === SpeedMetric.KPH) {
        return yardsToKph(speedYardsPerSecond);
    }
    return yardsToMph(speedYardsPerSecond);
};
function physicalMetrics(microsecond, { steps }, opts) {
    const options = { ...DEFAULT_OPTIONS, ...opts };
    const current = steps.find(byClosestMicrosecond(microsecond));
    const previousMicrosecond = microsecond - options.offset;
    const previous = steps.find(byClosestMicrosecond(previousMicrosecond));
    if (!(current === null || current === void 0 ? void 0 : current.pitch) || !(previous === null || previous === void 0 ? void 0 : previous.pitch))
        return { speed: 0 };
    const timeDifferenceInSeconds = microsecondsToSeconds(current.timestamp - previous.timestamp);
    const speed = calculateSpeed(previous.pitch.x, // x1
    current.pitch.x, // x2
    previous.pitch.y, // y1
    current.pitch.y, // y2
    timeDifferenceInSeconds, options.metric);
    return { speed };
}

export { physicalMetrics as default };
//# sourceMappingURL=physicalMetrics.js.map
